<template lang="pug">
  .container-outlay-coin.container-padding
    c-header
      template(slot="left")
        el-breadcrumb(separator="/")
          el-breadcrumb-item(to="/outlay") 营销账户管理
          el-breadcrumb-item(:to="detailURL") 营销账户详情
          el-breadcrumb-item 积力宝详情
    c-box
      .point-rule
        .display-block 人民币与积力宝兑换比例为 1元 ：1000分
        .point-hint(@click="showHint") ？
      .point-outer-container
        .point-container
          .point-title 已充值
          .point-amount {{ typeof(coinDetail.total_amount) === 'number' ? coinDetail.total_amount : '-' }}
        .point-container
          .point-title 库存
          .point-amount {{ typeof(coinDetail.present_balance) === 'number' ? coinDetail.present_balance : '-' }}
        //- .point-container
          .point-title 已发放
          .point-amount {{ typeof(coinDetail.total_amount) === 'number' ? coinDetail.total_amount - coinDetail.present_balance - coinDetail.special_balance : '-' }}
        .point-container
          .point-title.point-title-hint
            .display-block 专项积力宝
            el-tooltip(placement="right")
              .point-hint ？
              template(slot="content")
                .display-block 授权的应用可以把待发放的积力宝转换为专项积力宝，用于活动发放或其他专项用途发放。
                .display-block 待发放积力宝转换为专项积力宝后，只能由负责转换的应用控制发放。
          .point-amount {{ typeof(coinDetail.special_balance) === 'number' ? coinDetail.special_balance : '-' }}
        .point-container
          .point-title 专项发放
          .point-amount {{ typeof(coinDetail.special_consume_amount) === 'number' ? coinDetail.special_consume_amount : '-' }}
        .point-container
          .point-title 直接发放
          .point-amount {{ typeof(coinDetail.direct_consume_amount) === 'number' ? coinDetail.direct_consume_amount : '-' }}
        .point-container
          .point-title 直接扣减
          .point-amount {{ (typeof(coinDetail.deduction_amount) === 'number' && typeof(coinDetail.special_deduction_amount) === 'number') ? coinDetail.deduction_amount + coinDetail.special_deduction_amount : '-' }}
      hr
      .point-outer-container
        .point-container
          .point-title 今日使用情况
          .point-date {{ (new Date()).getMonth() + 1 }}月{{ (new Date()).getDate() }}日
        .point-container
          .point-title 积力宝充值
          .point-amount {{ typeof(coinLiveDetail.recharge_amount) === 'number' ? coinLiveDetail.recharge_amount : '-' }}
        .point-container
          .point-title 专项分配
          .point-amount {{ typeof(coinLiveDetail.special_account_amount) === 'number' ? coinLiveDetail.special_account_amount : '-' }}
        .point-container
          .point-title 专项返还
          .point-amount {{ typeof(coinLiveDetail.special_back_amount) === 'number' ? coinLiveDetail.special_back_amount : '-' }}
        .point-container
          .point-title 专项发放
          .point-amount {{ typeof(coinLiveDetail.special_consume_amount) === 'number' ? coinLiveDetail.special_consume_amount : '-' }}
        .point-container
          .point-title 直接发放
          .point-amount {{ typeof(coinLiveDetail.direct_consume_amount) === 'number' ? coinLiveDetail.direct_consume_amount : '-' }}
        .point-container
          .point-title 直接扣减
          .point-amount {{ (typeof(coinLiveDetail.deduction_amount) === 'number' && typeof(coinLiveDetail.special_deduction_amount) === 'number') ? coinLiveDetail.deduction_amount + coinLiveDetail.special_deduction_amount : '-' }}
    c-box
      el-form(:model="$data", label-position="right", label-width="100px")
        el-row(:gutter="10")
          el-col(:span="12")
            el-form-item(label="日期")
              el-date-picker(v-model="date", type="daterange", placeholder="选择日期范围")
            el-form-item(label="")
              el-button(@click="showExportExcel", type="primary") 导出流水报表
          el-col(:span="12")
            el-form-item(label="")
              el-button(@click="setFilter", type="primary") 搜索
              el-button(@click="timeReset") 重置时间
              el-button(@click="clearFilter", v-show="hasFilter") 清除
      el-table(:data="list", fit, v-loading="listLoading")
        el-table-column(property="date", label="日期", min-width="125", show-tooltip-when-overflow)
        el-table-column(property="recharge_amount", label="积力宝充值", min-width="125", show-tooltip-when-overflow)
        el-table-column(property="special_account_amount", label="专项分配", min-width="125", show-tooltip-when-overflow)
        el-table-column(property="special_back_amount", label="专项返还", min-width="125", show-tooltip-when-overflow)
        el-table-column(property="consume_amount", label="积力宝发放", min-width="125", show-tooltip-when-overflow)
        el-table-column(property="special_consume_amount", label="专项发放", min-width="100", show-tooltip-when-overflow)
        el-table-column(property="direct_consume_amount", label="直接发放", min-width="100", show-tooltip-when-overflow)
        el-table-column(label="直接扣减", min-width="100", show-tooltip-when-overflow, v-slot="{ row }").
          {{ row.deduction_amount + row.special_deduction_amount }}
        el-table-column(label="操作", min-width="125", align="right", v-slot="{ row }")
          .row-toolbox
            el-button(type="primary", @click="toExportSingleDay(row.date)") 导出报表
      .container-pagination
        el-pagination(layout="sizes, prev, pager, next, total",
          :current-page="page", :total="total", :page-size="size", :page-sizes="[5, 10, 15, 20, 25, 50]",
          @size-change="changeListSize", @current-change="getList")

    el-dialog(title="导出流水报表", :visible.sync="exportExcel.show")
      el-form(:model="exportExcel", label-position="right", label-width="100px")
        el-form-item(label="") 如果只需导出一天的报表，导出日期范围首末设置为同一天即可。
        el-form-item(label="导出日期", required)
          el-date-picker(v-model="exportExcel.date", type="daterange", placeholder="选择日期范围")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="toExportExcel()") 导出
        el-button(@click="hideExportExcel()") 取消

    el-dialog(title="积力宝说明", :visible.sync="hint.show", width="800px")
      p 1、积力宝的最小颗粒为”个“，本页面内所有积力宝数据都是在当前营销账户下的，不包含其他营销账户下的积力宝数据。只有授权的应用才能操作您营销账户下的积力宝。
      img(src="/coinhint.png").display-block.margin-center
      p 2、积力宝数量名词解释：
      p #[span.bold 已充值]：累计充值的积力宝数量；
      p #[span.bold 库存]：扣除掉专项积力宝、已发放积力宝后，剩余可直接发放的积力宝数量。库存积力宝可直接发放给用户；
      p #[span.bold 专项积力宝]：把库存的积力宝转换为专项积力宝，用于活动发放或其他专项用途发放。库存积力宝转换为专项积力宝后，只能由负责转换的应用控制发放，避免其他授权的应用操作该笔积力宝。专项积力宝在活动结束后若还有剩余，可返还回库存积力宝中。
      p #[span.bold 累计发放]：已成功发放给用户的积力宝数量。
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="hideHint()") 关闭
</template>

<script>
export default {
  data () {
    return {
      page:   1,
      size:   10,
      status: 0,
      list:   [],
      total:  0,

      listLoading:  false,

      coin_id:    null,
      filters:    {},
      date:       [],
      hasFilter:  false,

      coinDetail: {
        coin_id:          null,
        present_balance:  null,
        special_amount:   null,
        total_amount:     null,
      },
      coinLiveDetail: {
        consume_amount:         null, // 发放额, 虚拟货币最小单位
        recharge_amount:        null, // 充值额, 虚拟货币最小单位
        special_account_amount: null, // 专项账户额, 虚拟货币最小单位
        special_back_amount:    null, // 专项返还额, 虚拟货币最小单位
      },

      exportExcel: {
        show:     false,
        date:     [],
      },

      hint: {
        show:     false,
      },
    };
  },
  computed: {
    outlay_account_id () {
      return this.$route.params.outlay_account_id;
    },
    detailURL () {
      return `/outlay/${this.outlay_account_id}`;
    }
  },
  methods: {
    showExportExcel () {
      this.exportExcel = {
        show:     true,
        date:     [],
      };
    },
    hideExportExcel () {
      this.exportExcel = {
        show:     false,
        date:     [],
      };
    },
    toExportSingleDay (_date) {
      const date = _date.split(' ')[0];
      this.exportExcel.date = [date, date];
      this.toExportExcel();
    },
    toExportExcel () {
      if (!this.exportExcel || this.exportExcel.date.length !== 2) {
        this.$message({
          type:     'warning',
          message:  `请输入报表导出日期范围`,
        });
        return;
      }
      const date = [this.$dateFormatter(this.exportExcel.date[0]), this.$dateFormatter(this.exportExcel.date[1])];

      const baseURL = '/mch_web/v1/mch_payment/export_coin_day_detail';
      const url = `${baseURL}?outlay_account_id=${this.outlay_account_id}&` +
                  `start_date=${date[0]}&end_date=${date[1]}`;

      console.log(url);
      window.open(url);

      this.hideExportExcel();
    },
    showHint () {
      this.hint = {
        show:   true,
      };
    },
    hideHint () {
      this.hint = {
        show:   false,
      };
    },

    getCoinDetail () {
      return this.$store.dispatch('GET_OUTLAY_ACCOUNT_COIN_DETAIL', this.outlay_account_id).then((data) => {
        this.coinDetail = data;
        return data;
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `获取积力宝详情失败。${code}：${msg}`,
        });
      });
    },
    getCoinLiveDetail () {
      return this.$store.dispatch('GET_OUTLAY_ACCOUNT_COIN_LIVE_DETAIL', this.outlay_account_id).then((data) => {
        this.coinLiveDetail = data;
        return data;
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `获取当天积力宝使用情况失败。${code}：${msg}`,
        });
      });
    },

    timeReset () {
      this.date = [];
      this.refresh();
    },
    setFilter () {
      if (Array.isArray(this.date) && this.date.length === 2) {
        this.hasFilter = true;
      } else {
        this.hasFilter = false;
      }

      this.refresh();
    },
    clearFilter () {
      this.hasFilter = false;
      this.timeReset();
      this.refresh();
    },
    refresh () {
      this.getList(this.page);
    },
    changeListSize (size = 20) {
      this.size = size;
      this.getList(1);
    },
    getList (page = 1) {
      if (!this.listLoading) {
        this.page = page;
        this.listLoading = true;
      } else {
        return;
      }

      const _filters = Object.assign({}, this.filters, {
        outlay_account_id:  this.outlay_account_id,
        coin_id:            this.coinDetail.coin_id,
        start_date:         (Array.isArray(this.date) && typeof this.date[0] !== 'undefined') ? this.$dateFormatter(this.date[0]) : null,
        end_date:           (Array.isArray(this.date) && typeof this.date[1] !== 'undefined') ? this.$dateFormatter(this.date[1]) : null,
      });
      this.$store.dispatch('GET_OUTLAY_ACCOUNT_COIN_LIST', Object.assign({
        offset:   this.size * (this.page - 1),
        limit:    this.size,
        stat:     true,
      }, _filters)).then((data) => {
        this.list = data.list;
        this.total = data.total;
      }).catch(({ msg }) => {
        this.$alert(`${msg}`, {
          type:     'error'
        });
      }).finally(() => {
        this.listLoading = false;
      });
    },
  },
  mounted () {
    this.getCoinDetail().then(() => {
      this.getList(1);
      this.getCoinLiveDetail();
    });
  },
};
</script>
